import React from "react";

export const TriggersIcon = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0271 6.43697C11.0098 6.36351 10.9745 6.29547 10.9246 6.2389C10.8746 6.18233 10.8114 6.13898 10.7407 6.1127L7.4401 4.87463L8.28 0.673427C8.29901 0.575814 8.28577 0.474663 8.24226 0.385239C8.19874 0.295815 8.12733 0.222969 8.03878 0.177694C7.95024 0.132419 7.84937 0.117172 7.7514 0.134253C7.65343 0.151334 7.56367 0.199817 7.49567 0.272385L1.07901 7.14739C1.02689 7.2023 0.98919 7.26927 0.969272 7.34231C0.949354 7.41535 0.947839 7.49219 0.964862 7.56595C0.981886 7.63972 1.01692 7.70813 1.06683 7.76505C1.11674 7.82198 1.17997 7.86565 1.25088 7.89218L4.5526 9.13025L3.715 13.3269C3.69598 13.4245 3.70922 13.5256 3.75274 13.6151C3.79625 13.7045 3.86766 13.7773 3.95621 13.8226C4.04475 13.8679 4.14562 13.8831 4.24359 13.866C4.34156 13.849 4.43132 13.8005 4.49932 13.7279L10.916 6.85291C10.9672 6.79798 11.0041 6.73133 11.0234 6.6588C11.0428 6.58627 11.0441 6.5101 11.0271 6.43697ZM4.93015 11.9272L5.53 8.92629C5.55146 8.81986 5.53445 8.70927 5.48199 8.61421C5.42953 8.51915 5.34503 8.4458 5.24354 8.40723L2.21625 7.26999L7.06427 2.07593L6.465 5.07686C6.44353 5.18329 6.46054 5.29389 6.513 5.38895C6.56546 5.48401 6.64996 5.55736 6.75145 5.59593L9.77645 6.7303L4.93015 11.9272Z"
        fill="currentColor"
      />
    </svg>
  );
};
